(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fortune-spinner-mock"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function motionChange(callback) { if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', callback); else reducedMotion.addListener(callback); }
    const sticky = root.querySelector('.fs-sticky');
    if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: .1 }).observe(root.querySelector('.fs-consult'));
    const tabs = [...root.querySelectorAll('[data-face-tab]')];
    const panels = [...root.querySelectorAll('[data-face-panel]')];
    const photo = root.querySelector('[data-face-image]');
    let current = 0;
    function face(index, focus) {
      if (!tabs.length || !panels.length || !photo) return;
      current = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === current)); tab.tabIndex = i === current ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== current; });
      photo.src = panels[current].dataset.image;
      photo.alt = panels[current].dataset.imageAlt;
      photo.style.setProperty('--fs-image-position', panels[current].dataset.imagePosition || '50% 50%');
      photo.style.setProperty('--fs-image-scale', panels[current].dataset.imageScale || '1');
      root.querySelector('[data-face-count]').textContent = String(current + 1).padStart(2, '0') + ' / ' + String(tabs.length).padStart(2, '0');
      if (focus) tabs[current].focus();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => face(i, false));
      tab.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); face(current + (event.key === 'ArrowRight' ? 1 : -1), true); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); face(event.key === 'Home' ? 0 : tabs.length - 1, true); }
      });
    });
    face(0, false);
    root.querySelector('[data-spin]')?.addEventListener('click', () => face(current + 1 + Math.floor(Math.random() * Math.max(1, tabs.length - 1)), false));
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...track.children];
      const count = gallery.querySelector('[data-gallery-count]');
      const dotsBox = gallery.querySelector('[data-gallery-dots]');
      const pause = gallery.querySelector('[data-gallery-pause]');
      let selected = 0, visible = false, stopped = reducedMotion.matches, timer, frame, gesture, suppressZoomUntil = 0;
      const dots = slides.map((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.galleryDot = String(i);
        button.setAttribute('aria-label', '写真 ' + (i + 1) + ' を表示');
        if (gallery.hasAttribute('data-gallery-thumbnails')) {
          const image = slide.querySelector('img');
          const thumb = document.createElement('img'); thumb.src = image.getAttribute('src'); thumb.alt = ''; thumb.width = 56; thumb.height = 56; thumb.loading = 'lazy';
          button.style.setProperty('--fs-image-position', slide.style.getPropertyValue('--fs-image-position') || '50% 50%');
          button.style.setProperty('--fs-image-scale', slide.style.getPropertyValue('--fs-image-scale') || '1');
          button.append(thumb); button.setAttribute('aria-label', '仕様写真：' + slide.querySelector('[data-spec-title]').textContent);
        }
        dotsBox.append(button); button.addEventListener('click', () => { stop(); go(i); });
        return button;
      });
      function update() {
        selected = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) < Math.abs(slides[best].getBoundingClientRect().left - track.getBoundingClientRect().left) ? i : best, 0);
        if (track.scrollWidth - track.clientWidth > 2 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) selected = slides.length - 1;
        count.textContent = String(selected + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === selected)));
        if (gallery.hasAttribute('data-gallery-thumbnails') && dots[selected]) {
          const dot = dots[selected];
          if (dot.offsetLeft < dotsBox.scrollLeft || dot.offsetLeft + dot.offsetWidth > dotsBox.scrollLeft + dotsBox.clientWidth) dotsBox.scrollTo({ left: dot.offsetLeft - (dotsBox.clientWidth - dot.offsetWidth) / 2, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      }
      function go(index) {
        const slide = slides[(index + slides.length) % slides.length];
        const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - padding;
        track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      function schedule() {
        clearInterval(timer);
        if (gallery.hasAttribute('data-auto-gallery') && slides.length > 1 && visible && !stopped && !reducedMotion.matches && !document.hidden) timer = setInterval(() => go(selected + 1), Math.max(5000, Number(gallery.dataset.galleryInterval) || 5000));
      }
      function stop() { stopped = true; schedule(); if (pause) { pause.textContent = '自動再生'; pause.setAttribute('aria-pressed', 'true'); } }
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => { stop(); go(selected - 1); });
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => { stop(); go(selected + 1); });
      pause?.addEventListener('click', () => { stopped = !stopped; pause.textContent = stopped ? '自動再生' : '一時停止'; pause.setAttribute('aria-pressed', String(stopped)); schedule(); });
      track.addEventListener('pointerdown', event => {
        stop();
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') { gesture = null; suppressZoomUntil = 0; return; }
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, moved: false };
      }, { passive: true });
      if (!('PointerEvent' in window)) track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('pointermove', event => {
        if (gesture && gesture.id === event.pointerId && (Math.abs(event.clientX - gesture.x) > 10 || Math.abs(event.clientY - gesture.y) > 10)) gesture.moved = true;
      }, { passive: true });
      function endGesture(event) {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (gesture.moved || Math.abs(track.scrollLeft - gesture.scroll) > 6 || event.type === 'pointercancel') suppressZoomUntil = performance.now() + 700;
        gesture = null;
      }
      track.addEventListener('pointerup', endGesture, { passive: true });
      track.addEventListener('pointercancel', endGesture, { passive: true });
      track.addEventListener('click', event => {
        if (event.pointerType === 'mouse') return;
        if (event.detail !== 0 && event.target.closest('[data-gallery-zoom]') && (performance.now() < suppressZoomUntil || gesture?.moved)) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      }, true);
      gallery.querySelectorAll('[data-gallery-zoom]').forEach(button => button.addEventListener('click', stop));
      track.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); stop(); go(selected + (event.key === 'ArrowRight' ? 1 : -1)); } });
      track.tabIndex = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, { passive: true });
      gallery.addEventListener('focusin', () => { clearInterval(timer); });
      gallery.addEventListener('focusout', () => { schedule(); });
      gallery.addEventListener('mouseenter', () => clearInterval(timer));
      gallery.addEventListener('mouseleave', schedule);
      document.addEventListener('visibilitychange', schedule);
      motionChange(() => { if (reducedMotion.matches) stop(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .3 }).observe(gallery);
      else { visible = true; schedule(); }
      if (slides.length < 2) gallery.querySelector('[data-gallery-controls]').hidden = true;
      if (pause && stopped) { pause.textContent = '自動再生'; pause.setAttribute('aria-pressed', 'true'); }
      update(); window.addEventListener('resize', update, { passive: true });
    });
    const specDialog = root.querySelector('[data-spec-dialog]');
    let zoomTrigger;
    if (specDialog) {
      const viewer = specDialog.querySelector('[data-spec-viewer]');
      const zoomImage = specDialog.querySelector('[data-spec-dialog-image]');
      let zoom = 1, focalX = .5, focalY = .5;
      function centerImage() {
        viewer.scrollLeft = Math.max(0, Math.min(viewer.scrollWidth - viewer.clientWidth, viewer.scrollWidth * focalX - viewer.clientWidth / 2));
        viewer.scrollTop = zoom > 1 ? Math.max(0, Math.min(viewer.scrollHeight - viewer.clientHeight, viewer.scrollHeight * focalY - viewer.clientHeight / 2)) : 0;
      }
      function magnify(value) {
        zoom = Math.max(1, Math.min(3, value));
        viewer.style.setProperty('--fs-spec-zoom', String(zoom));
        specDialog.querySelector('[data-spec-scale]').textContent = Math.round(zoom * 100) + '%';
        specDialog.querySelector('[data-spec-zoom-out]').disabled = zoom === 1;
        specDialog.querySelector('[data-spec-zoom-in]').disabled = zoom === 3;
        requestAnimationFrame(centerImage);
      }
      zoomImage.addEventListener('load', centerImage);
      specDialog.querySelector('[data-spec-zoom-in]').addEventListener('click', () => magnify(zoom + .5));
      specDialog.querySelector('[data-spec-zoom-out]').addEventListener('click', () => magnify(zoom - .5));
      specDialog.querySelector('[data-spec-zoom-reset]').addEventListener('click', () => magnify(1));
      root.querySelectorAll('[data-gallery-zoom]').forEach(button => button.addEventListener('click', () => {
        zoomTrigger = button;
        const slide = button.closest('.fs-gallery-slide');
        const image = specDialog.querySelector('[data-spec-dialog-image]');
        image.src = button.dataset.zoomSrc; image.alt = button.querySelector('img').alt;
        specDialog.querySelector('[data-spec-dialog-title]').textContent = slide.querySelector('[data-spec-title]').textContent;
        specDialog.querySelector('[data-spec-dialog-body]').textContent = slide.querySelector('[data-spec-body]').textContent;
        if (typeof specDialog.showModal === 'function') specDialog.showModal();
        else specDialog.setAttribute('open', '');
        const slideStyle = getComputedStyle(slide);
        const position = slideStyle.getPropertyValue('--fs-image-position').match(/(-?[\d.]+)%\s+(-?[\d.]+)%/);
        focalX = position ? Math.max(0, Math.min(1, Number(position[1]) / 100)) : .5;
        focalY = position ? Math.max(0, Math.min(1, Number(position[2]) / 100)) : .5;
        const slideZoom = Number(slideStyle.getPropertyValue('--fs-image-scale')) || 1;
        magnify(button.classList.contains('fs-spec-detail') ? Math.max(2, slideZoom) : slideZoom);
      }));
      function closeSpec() { if (typeof specDialog.close === 'function') specDialog.close(); else { specDialog.removeAttribute('open'); zoomTrigger?.focus(); } }
      specDialog.querySelector('[data-spec-close]').addEventListener('click', closeSpec);
      specDialog.addEventListener('close', () => zoomTrigger?.focus());
      specDialog.addEventListener('click', event => { const rect = specDialog.getBoundingClientRect(); if (event.target === specDialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeSpec(); });
      specDialog.addEventListener('keydown', event => { if (event.key === 'Escape' && typeof specDialog.close !== 'function') { event.preventDefault(); closeSpec(); } });
    }
    const choice = root.querySelector('[data-consult-choice]');
    const ideaInput = root.querySelector('[data-consult-idea-input]');
    root.querySelectorAll('[data-consult-idea]').forEach(link => link.addEventListener('click', () => {
      const idea = link.dataset.consultIdea;
      ideaInput.value = idea; choice.querySelector('[data-consult-choice-label]').textContent = idea; choice.hidden = false;
    }));
    root.querySelector('[data-consult-clear]')?.addEventListener('click', () => { ideaInput.value = ''; choice.hidden = true; });
    root.querySelectorAll('.fs-video-media video').forEach(video => {
      const fallback = video.parentElement.querySelector('[data-video-play]');
      let visible = false, pending = false, manuallyPaused = false, programmaticPause = false;
      video.muted = true; video.defaultMuted = true; video.playsInline = true;
      video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
      function pauseVideo() { if (!video.paused) { programmaticPause = true; video.pause(); } }
      async function playVideo(manual = false) {
        if (pending || (!manual && (!visible || reducedMotion.matches || document.hidden || manuallyPaused))) return;
        pending = true;
        try { await video.play(); if (!visible || document.hidden) pauseVideo(); if (fallback) fallback.hidden = true; }
        catch { if (fallback && visible) fallback.hidden = false; }
        finally { pending = false; }
      }
      video.addEventListener('pause', () => { if (programmaticPause) { programmaticPause = false; return; } if (visible) manuallyPaused = true; });
      video.addEventListener('play', () => { manuallyPaused = false; if (fallback) fallback.hidden = true; });
      fallback?.addEventListener('click', () => { if (!('IntersectionObserver' in window)) visible = true; manuallyPaused = false; playVideo(true); });
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) { if (reducedMotion.matches) { if (fallback) fallback.hidden = false; } else playVideo(); }
        else { pauseVideo(); if (fallback) fallback.hidden = true; }
      }, { threshold: .35 }).observe(video);
      else if (fallback) fallback.hidden = false;
      video.addEventListener('canplay', () => playVideo());
      document.addEventListener('visibilitychange', () => { if (document.hidden) pauseVideo(); else playVideo(); });
      window.addEventListener('pagehide', pauseVideo);
      motionChange(() => { if (reducedMotion.matches) { pauseVideo(); if (fallback && visible) fallback.hidden = false; } else playVideo(); });
    });
  }
  document.querySelectorAll('[data-spinner-mock]').forEach(init);
  document.addEventListener('shopify:section:load', event => { const root = event.target.querySelector('[data-spinner-mock]'); if (root) init(root); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
